import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import media from "@irati/ui/src/global/media"

export default styled(Card)`
  ${({theme}) => css`
    border-radius: 0 0 3px 3px;
    padding: ${theme.spacing.five} ${theme.spacing.four} ${theme.spacing.two};
    margin-bottom: ${theme.spacing.one};
    box-shadow: none;
    border-bottom: 5px solid transparent;
    ${media.desktop`
      padding: ${theme.spacing.five} ${theme.spacing.four} ${theme.spacing.two};
    `}
  
    ${media.tablet`
      padding: 25px ${theme.spacing.two} 10px ${theme.spacing.two};
    `}
  `}
`
